module.exports = __webpack_public_path__ + "static/media/icono_seccioncereales.0d6dd58e.png";